import React, { useState, useEffect, useRef } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Container, Button, Typography, Grid, Card, CardContent, AppBar } from "@material-ui/core";
import Slider from "react-slick";
import http from '../http';
import { useStore } from '../store';
import { Player, BigPlayButton, PosterImage } from 'video-react';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import 'video-react/dist/video-react.css';
import './slider.css'
import { useParams, Link, Redirect } from 'react-router-dom';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import PropTypes from 'prop-types';
import fileDownload from 'js-file-download';
import download from 'downloadjs';
import classNames from "classnames";
const useStyles = makeStyles((theme) => ({
    root: {
        flex: "1 0 auto",
        margin: 20
    },
    paper: {
        display: "flex"
    },
    typo: {
        padding: 10,
        margin: 10,
    },
    card0: {
        display: "flex",
        minHeight: "100%",
        justifyContent: "space-between",

        flexDirection: "column",
        minWidth: "100%",
        marginTop: 0,
        marginBottom: 0,
        padding: 12,
    },

    tabs0: {

        backgroundColor: "#ffffff"
    },
    viewer: {
        height: "100vh"
    },
    wrapper: {
        padding: 50
    },
    imgcss: {
        maxWidth: '100%',
        maxHeight: '100%',
        marginLeft: "auto",
        marginRight: "auto"
    },
    imgcssv: {
        maxWidth: '100%',
        maxHeight: '100%',
        marginLeft: "auto",
        marginRight: "auto"
    },
    tdiv: {
        padding: 2
    },
    tdivv: {
        padding: 2
    },
    timg: {
        maxWidth: '100%',
        maxHeight: '100%',
        /*border:"2px solid #00BCD4",*/

    },
    timgv: {
        maxWidth: '100%',
        maxHeight: '100%',
        /*border:"2px solid #00BCD4",*/

    },
    tablist: {
        fontSize: "0.875rem",
        fontWeight: 500
    },
    hslidei: {

    },
    hslidet: {

    },
    hslideiv: {

    },
    hslidetv: {

    }
}));



function SingleExam(props) {
    const classes = useStyles();
    const [nav1, setNav1] = useState(null);
    const [nav2, setNav2] = useState(null);
    const refSlide1 = useRef(null);
    const refSlide2 = useRef(null);
    const [nav1v, setNav1v] = useState(null);
    const [nav2v, setNav2v] = useState(null);
    const refSlide1v = useRef(null);
    const refSlide2v = useRef(null);
    const { state, dispatch } = useStore();
    const config = require('../config');
    var callback = function (key) {
        console.log('tab', key);
        //if (refSlide1.current)
        setNav1(refSlide1.current);
        //if (refSlide2.current)
        setNav2(refSlide2.current);
        setNav1v(refSlide1v.current);
        setNav2v(refSlide2v.current);
    };
    let { ID } = useParams();
    const [row, setRow] = useState({});
    const [media, setMedia] = useState([]);
    const [pdf, setPdf] = useState([]);
    const [pageNumber, setPageNumber] = useState(1);
    const [numPages, setNumPages] = useState(0);

    function handleDownload(url) {
        let filename = url.split('/').slice(-1)[0];
        http.get(url, {
            responseType: 'blob',
        })
            .then((res) => {
                const content = res.headers['content-type'];
                download(res.data, filename, content);
                //fileDownload(res.data, filename)
            })
    }
    function handleDownload2(url) {
        let filename = url.split('/').slice(-1)[0];
        http.get(url, {
            responseType: 'blob',
        }).then((res) => {
            //const content = res.headers['content-type'];
            //download(res.data, filename, content);
            //fileDownload(res.data, filename)
            /*
            var reader = new FileReader();
            var out = new Blob([res.data], { type: 'application/pdf' });
            reader.onload = function (e) {
                window.location.href = reader.result;
            }
            reader.onloadend = function (e) { if (e.target.result) console.log("Success parsing file", filename) }
            reader.onerror = function (e) { console.log('Error parsing file', e) }
            reader.readAsDataURL(out);
            */
            var blob = new Blob([res.data], { type: "application/pdf" });
            var fileURL = URL.createObjectURL(blob);
            var a = document.createElement('a');
            a.href = fileURL;
            //a.target = '_self';
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            /*
            let x=window.open();
            let iframe=x.document.createElement('iframe');
            iframe.width='100%';
            iframe.height='100%';
            iframe.frameBorder=0;
            iframe.style="border: 0";
            iframe.src=fileURL;
            x.document.body.appendChild(iframe);
            */
        })
    }

    const settingsMain = {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        adaptiveHeight: true
    };

    const settingsThumbs = {
        slidesToShow: 5,
        slidesToScroll: 1,
        arrows: false,
        centerMode: true,
        focusOnSelect: true

    };
    const settingsMainv = {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        vertical: true,
        adaptiveHeight: true,
        beforeChange: (oldIndex, newIndex) => { console.log(refSlide1, refSlide2, oldIndex, newIndex); },
        afterChange: (newIndex)=>{setPageNumber(newIndex+1)}
    };

    const settingsThumbsv = {
        slidesToShow: 5,
        slidesToScroll: 1,
        vertical: true,
        beforeChange: (oldIndex, newIndex) => { console.log(refSlide1, refSlide2, oldIndex, newIndex); },
        focusOnSelect: true,
        arrows: false
    };
    function previousPage() {
        refSlide2v.current.slickPrev();
        setPageNumber(prevPageNumber => prevPageNumber - 1);
    }

    function nextPage() {
        refSlide2v.current.slickNext();
        setPageNumber(prevPageNumber => prevPageNumber + 1);
    }
    useEffect(() => {
        console.log('in effect', ID);
        //if (refSlide1.current)
        setNav1(refSlide1.current);
        //if (refSlide2.current)
        setNav2(refSlide2.current);
        setNav1v(refSlide1v.current);
        setNav2v(refSlide2v.current);
        //

        let headers = { 'headers': { 'x-access-token': state.token } }
        http.get('/exam/single/' + ID, headers)
            .then((res) => {
                setRow(res.data.row);
                setMedia(res.data.rs.media);
                setPdf(res.data.rs.report);
                setNumPages(res.data.rs.report[0].imgs.length);
                console.log('data', res.data);
                //
            })
            .catch((error) => {
                console.log('error', error);
            })
            .finally(() => {

            });
        {/*    
        let rr = { "status": "OK", "row": { "_id": "5feb3b0df3162575f23ee282", "MRN": "000000000B", "accessionNumber": "A9314720", "birthday": "19560701", "bladderLeftData": "N,N,N,N,N,N", "bladderRightData": "N,N,N,N,N,N", "bladderVolumeData": "N,N,N,N,N,N", "columnsNum": "1655,N,1655,1655,1655,N", "date": "11/20/2020,11/20/2020,11/20/2020,11/20/2020,11/20/2020,11/20/2020,11/20/2020", "duration": "207367", "ellipseData": "N,N,N,N,ellipse1area 6.406cm²,N", "firstName": "wu", "frameTime": "125.00,N,125.00,125.00,125.00,N", "imagePath": "/data/user/0/com.leltek.leltekultrasound/files/000000000B_Cher__wu_20201120_120253.jpg,/data/user/0/com.leltek.leltekultrasound/files/video/000000000B_Cher__wu_20201120_120255.mp4,/data/user/0/com.leltek.leltekultrasound/files/000000000B_Cher__wu_20201120_120309.jpg,/data/user/0/com.leltek.leltekultrasound/files/000000000B_Cher__wu_20201120_120313.jpg,/data/user/0/com.leltek.leltekultrasound/files/000000000B_Cher__wu_20201120_120317.jpg,/data/user/0/com.leltek.leltekultrasound/files/video/000000000B_Cher__wu_20201120_120320.mp4", "indication": "", "instance": "0,0,0,0,0,0", "lastName": "Cher ", "measureData": "N,N,N,N,line1length 2.039cm,N", "performedBy": "BROWN", "pixelSpacing": "0_0,0_0,0_0,0_0,0_0,0_0", "polygonData": "N,N,N,N,N,N", "referringPhysician": "", "referringRecord": "", "rowsNum": "976,N,976,976,976,N", "scheduledStationName": "STN94594", "series": "5,N,5,5,5,N", "sex": "Other", "ssid": "47.20711401,N,47.20711401,47.20711401,47.20711401,N", "startTime": "1605844795439", "stationName": "", "studyDescription": "EXAM8", "time": "11:59:55,12:02:53,12:02:58,12:03:09,12:03:13,12:03:17,12:03:20", "userid": "5feb3a1b5ff89493c9984760", "createdAt": "2020-12-29T14:19:57.156Z", "updatedAt": "2020-12-29T14:19:57.156Z", "__v": 0 }, "rs": { "media": [{ "id": 8, "src": "http://localhost:5050/api/v1/static/exams/5feb3a1b5ff89493c9984760/000000000B/000000000B_Cher__wu_20201120_120255.mp4", "thumb": "http://localhost:5050/api/v1/static/exams/5feb3a1b5ff89493c9984760/000000000B/thumb_000000000B_Cher__wu_20201120_120255.png" }, { "id": 9, "src": "http://localhost:5050/api/v1/static/exams/5feb3a1b5ff89493c9984760/000000000B/000000000B_Cher__wu_20201120_120253.jpg", "thumb": "http://localhost:5050/api/v1/static/exams/5feb3a1b5ff89493c9984760/000000000B/thumb_000000000B_Cher__wu_20201120_120253.jpg" }, { "id": 10, "src": "http://localhost:5050/api/v1/static/exams/5feb3a1b5ff89493c9984760/000000000B/000000000B_Cher__wu_20201120_120309.jpg", "thumb": "http://localhost:5050/api/v1/static/exams/5feb3a1b5ff89493c9984760/000000000B/thumb_000000000B_Cher__wu_20201120_120309.jpg" }, { "id": 11, "src": "http://localhost:5050/api/v1/static/exams/5feb3a1b5ff89493c9984760/000000000B/000000000B_Cher__wu_20201120_120313.jpg", "thumb": "http://localhost:5050/api/v1/static/exams/5feb3a1b5ff89493c9984760/000000000B/thumb_000000000B_Cher__wu_20201120_120313.jpg" }, { "id": 12, "src": "http://localhost:5050/api/v1/static/exams/5feb3a1b5ff89493c9984760/000000000B/000000000B_Cher__wu_20201120_120317.jpg", "thumb": "http://localhost:5050/api/v1/static/exams/5feb3a1b5ff89493c9984760/000000000B/thumb_000000000B_Cher__wu_20201120_120317.jpg" }], "report": [] } }
        setRow(rr.row);
        setMedia(rr.rs.media);
        setPdf(rr.rs.report);
        */}
        console.log('ref', refSlide1, refSlide1.current);
    }, []);
    const convBirth = (bday) => {
        if (bday) {
            let a = /(\d{4})(\d{2})(\d{2})/;
            let b = a.exec(bday);
            console.log('bday', bday, b);
            return (b[1] + '-' + b[2] + '-' + b[3])
        }
        else {
            return ('-')
        }
    }
    const getExamDate = (d, t) => {
        let a = /(\d{2})\/(\d{2})\/(\d{4})/;
        if (d && t) {
            let b = a.exec(d.split(',')[0]);
            let examdata = b[3] + '-' + b[1] + '-' + b[2] + ' ' + t.split(',')[0];
            return (
                examdata
            );
        }
        else {
            return ('-')
        }
    }
    return (
        <div className={classes.root}>
            <Container maxWidth="md">
                <Tabs defaultIndex={1} defaultFocus={true} onSelect={callback}>
                    <TabList className={classNames("react-tabs__tab-list", classes.tablist)}>
                        <Tab>{state.dict.exams.title}</Tab>
                        <Tab>{state.dict.exams.detail}</Tab>
                        <Tab>{state.dict.exams.report}</Tab>
                    </TabList>
                    <TabPanel tab="tab 1" key="1" forceRender={false}>
                        <Redirect to="/exams" />
                    </TabPanel>
                    <TabPanel tab="tab 2" key="2" forceRender={true}>

                        <Grid container spacing={1}>
                            <Grid item md={8} sm={12} className={classes.paper}>
                                <Card className={classes.card0} elevation={0}>
                                    <Container maxWidth="md">

                                        <Slider className={classes.hslidei}
                                            ref={refSlide1} {...settingsMain}
                                            asNavFor={nav2}
                                        >
                                            {
                                                media.map((item) => {
                                                    if (item.src.endsWith('.mp4')) {
                                                        return (
                                                            <div key={item.id}>
                                                                <Player
                                                                    playsInline

                                                                    src={item.src}
                                                                >
                                                                    <BigPlayButton position="center" />
                                                                </Player>
                                                            </div>
                                                        );
                                                    }
                                                    else {
                                                        return (
                                                            <div key={item.id}>
                                                                <img alt="slide" className={classes.imgcss} src={item.src} />
                                                            </div>
                                                        )
                                                    }
                                                }

                                                )}
                                        </Slider>

                                    </Container>
                                    <Container maxWidth="md">
                                        <Slider className={classes.hslidet}
                                            ref={refSlide2} {...settingsThumbs}
                                            asNavFor={nav1}
                                        >
                                            {
                                                media.map((item) => {
                                                    return (
                                                        <div key={item.id} className={classes.tdiv}>
                                                            <img alt="thumb" className={classes.timg} src={item.thumb} />
                                                        </div>
                                                    )
                                                })
                                            }
                                        </Slider>
                                    </Container>
                                </Card>
                            </Grid>
                            <Grid item md={4} sm={12} className={classes.paper}>

                                <Card className={classes.card0} elevation={0}>
                                    <CardContent>
                                        <Typography variant="h3" gutterBottom>
                                            {row.firstName + ' ' + row.lastName}
                                        </Typography>
                                        <Typography variant="subtitle2" component="h2">
                                            {state.dict.exams.list.patient_id}: {row.MRN}<br />
                                            {state.dict.exams.list.patient_gender}: {row.sex}<br />
                                            {state.dict.exams.list.patient_bday}: {

                                                convBirth(row.birthday)
                                            }
                                        </Typography>
                                        <br /><br />
                                        <Typography variant="h6" component="p">
                                            {state.dict.exams.detail}:
                                </Typography>
                                        <Typography variant="subtitle2" component="h2">
                                            {state.dict.exams.list.clinician}: {row.performedBy}<br />
                                            {state.dict.exams.list.exam_date}: {getExamDate(row.date, row.time)}<br />
                                            {state.dict.exams.single.referrer}: {row.referringPhysician ? row.referringPhysician : '-'}<br />
                                            {state.dict.exams.list.scanner_id}: {row.ssid ? row.ssid.split(',')[0] : '-'}<br />
                                        </Typography>
                                    </CardContent>
                                </Card>
                            </Grid>
                        </Grid>
                    </TabPanel>
                    <TabPanel tab="tab 3" key="3" forceRender={true}>
                        <Grid container spacing={1}>
                            <Grid item md={8} sm={12} className={classes.paper}>
                                <Card className={classes.card0} elevation={0}>
                                    <Grid container spacing={1}>
                                        <Grid item md={2} className={classes.paper}>
                                            <Slider className={classes.vslidet}
                                                ref={refSlide1v} {...settingsThumbsv}
                                                asNavFor={nav2v}
                                            >
                                                {pdf.length > 0 &&
                                                    pdf[0].thumbs.map((item) => {
                                                        return (
                                                            <div key={pdf[0].id} className={classes.tdivv}>
                                                                <img alt="thumb" className={classes.timgv}
                                                                    src={pdf[0].furl + '/' + item} />
                                                            </div>
                                                        )
                                                    }
                                                    )}
                                            </Slider>
                                        </Grid>
                                        <Grid item md={10} className={classes.paper}>
                                            <Slider className={classes.vslidei}
                                                ref={refSlide2v} {...settingsMainv}
                                                asNavFor={nav1v}
                                            >
                                                {pdf.length > 0 &&
                                                    pdf[0].imgs.map((item) => {
                                                        return (
                                                            <div key={pdf[0].id} >
                                                                <img alt="slide" className={classes.imgcssv}
                                                                    src={pdf[0].furl + '/' + item} />
                                                            </div>
                                                        )
                                                    })
                                                }
                                            </Slider>
                                        </Grid>
                                    </Grid>
                                </Card>
                            </Grid>
                            <Grid item md={4} sm={12} className={classes.paper}>
                                <Card className={classes.card0} elevation={0}>
                                    <CardContent>
                                        <Typography variant="h3" gutterBottom>
                                            {row.firstName + ' ' + row.lastName}
                                        </Typography>
                                        <Typography variant="subtitle2" component="h2">
                                            {state.dict.exams.list.patient_id}: {row.MRN}<br />
                                            {state.dict.exams.list.patient_gender}: {row.sex}<br />
                                            {state.dict.exams.list.patient_bday}: {

                                                convBirth(row.birthday)
                                            }
                                        </Typography>
                                        <br /><br />
                                        <Typography variant="h6" component="p">
                                            {state.dict.exams.detail}:
                                    </Typography>
                                        <Typography variant="subtitle2" component="h2">
                                            {state.dict.exams.list.clinician}: {row.performedBy}<br />
                                            {state.dict.exams.list.exam_date}: {getExamDate(row.date, row.time)}<br />
                                            {state.dict.exams.single.referrer}: {row.referringPhysician ? row.referringPhysician : '-'}<br />
                                            {state.dict.exams.list.scanner_id}: {row.ssid ? row.ssid.split(',')[0] : '-'}<br />
                                        </Typography>
                                        <br /><br />
                                        <Typography>
                                            <Button
                                                variant="text"
                                                disabled={pageNumber <= 1}
                                                onClick={previousPage}
                                            >
                                                ◀
                                        </Button>
                                        Page {pageNumber || (numPages ? 1 : '-')} of {numPages || '-'}
                                            <Button
                                                variant="text"
                                                disabled={pageNumber >= numPages}
                                                onClick={nextPage}
                                            >
                                                ▶
                                        </Button>
                                        </Typography>
                                        <br /><br />
                                        {pdf.length ? (
                                            <Typography align="center">
                                                <Button onClick={() => { handleDownload2(pdf[0].src) }} variant="contained">Download Report</Button>
                                            </Typography>) : (<br />)}
                                    </CardContent>
                                </Card>
                            </Grid>
                        </Grid>
                    </TabPanel>
                </Tabs>
            </Container>

        </div >
    );
}

export default SingleExam;
